import {  Box, keyframes } from "@mui/material";

const bounce = keyframes`
    0%, 80%, 100% {
        transform: scale(0);
        opacity: 0.3;
    }
    40% {
        transform: scale(1);
        opacity: 1;
    }
`;

export default function({ delay }) {
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-block',
                width: 6,
                height: 6,
                bgcolor: '#FAED7A',
                borderRadius: '50%',
                margin: '0 2px',
                animation: `${bounce} 1.4s infinite ease-in-out`,
                animationDelay: delay,
            }}
        />
    );
}
